export default __webpack_public_path__ + "static/media/kalipso.d0193b2e.png";